export default __webpack_public_path__ + "static/media/longhairguy4x3.0a64f60f.png";